import React, { useEffect, useState } from 'react';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { useHistory } from "react-router-dom";
import api from '../../services/api';
import { updateUserInfo } from '../../services/user';
import InlineSVG from 'svg-inline-react';
import SuccessEdit from './SuccessEdit';

const ProfileStep3 = ({userData, formObject, stepStatus, setStepFinished, checkSign, stepFinished }) => {
  const history = useHistory();

  const [forceShowForm, setForceShowForm] = useState();

  const { handleSubmit: handleSubmit3, register: register3, errors: errors3, reset: resetForm, getValues, triggerValidation } = formObject;

  useEffect(() => {
    if(userData) {
      resetForm({
        productOne: userData.offer.products.productOne || '',
        productTwo: userData.offer.products.productTwo || '',
        productThree: userData.offer.products.productThree || '',
        productFour: userData.offer.products.productFour || '',
        productFive: userData.offer.products.productFive || '',
        serviceOne: userData.offer.services.serviceOne || '',
        serviceTwo: userData.offer.services.serviceTwo || '',
        serviceThree: userData.offer.services.serviceThree || '',
        serviceFour: userData.offer.services.serviceFour || '',
        serviceFive: userData.offer.services.serviceFive || '',
  
        availableToGivenWhen: userData.availableToGivenWhen || '',
        availableToGivenTime: userData.availableToGivenTime || ''
      });
    }
  }, [userData, resetForm]);
  
  const onSubmit = async(data) => {
    const {
      productOne,
      productTwo,
      productThree,
      productFour,
      productFive,
      serviceOne,
      serviceTwo,
      serviceThree,
      serviceFour,
      serviceFive,
      availableToGivenWhen,
      availableToGivenTime,
      } = data;

      const productArray = [productOne, productTwo, productThree, productFour, productFive];
      const serviceArray = [serviceOne, serviceTwo, serviceThree, serviceFour, serviceFive];

      try {
        const result = await api.post('/user-details', {
          step: 3,
          productOfferList: productArray,
          serviceOfferList: serviceArray,
          availableToGivenWhen: availableToGivenWhen,
          availableToGivenTime: availableToGivenTime
        });
        await updateUserInfo(result.data);
        setStepFinished(true);
        setForceShowForm(false);
        history.push('/meu-perfil');
      } catch(err){
        setStepFinished(false);
        setForceShowForm(false);
        window.alert('Erro interno do servidor: ' + err);
      }
  };

  return (
    <AccordionItem className="windbox -item">
      <AccordionItemHeading className="windbox -head">
        <AccordionItemButton className="windbox -button">
          <div className="windbox -button-target">
            {stepStatus['3'] &&
              <InlineSVG src={checkSign} className="windbox -position -finished"/>
            }
            {!stepStatus['3'] &&
              <span className="windbox -position">3</span>
            }
            <h3 className="windbox -title">Minhas disponibilidades</h3>
          </div>
          <span className="windbox -icon">
            <i className="icon"></i>
            <span className="sr-only">abrir</span>
          </span>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel className="windbox -panel">
        <div className="windbox -content">
          <form onSubmit={ handleSubmit3(onSubmit)} noValidate className={`${!stepFinished || forceShowForm ? '' : 'form -hide'}`}>
            <div className={`form -field ${errors3.productOne ? '-error' : ''}`}>
              <label htmlFor="productOne">
                Quais são os cinco produtos principais que você consegue oferecer?
              </label>
              <div className="form -group -gray">
                <input
                  type="text"
                  id="offerProductOne"
                  name="productOne"
                  autoComplete="off"
                  placeholder="Primeiro produto"
                  onChange={() => triggerValidation('serviceOne')}
                  ref={register3({
                    maxLength: 60,
                    validate: value => !(value.length < 3 && getValues('serviceOne').length < 3)
                  })}
                />
                { errors3.productOne?.type === 'maxLength' &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
                { errors3.productOne && errors3.productOne?.type !== 'maxLength' &&
                  <p className="form -message -error">Você precisa inserir ao menos um produto ou serviço que quer oferecer</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerProductTwo"
                  name="productTwo"
                  autoComplete="off"
                  placeholder="Segundo produto"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.productTwo &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerProductThree"
                  name="productThree"
                  autoComplete="off"
                  placeholder="Terceiro produto"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.productThree &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerProductFour"
                  name="productFour"
                  autoComplete="off"
                  placeholder="Quarto produto"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.productFour &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerProductFive"
                  name="productFive"
                  autoComplete="off"
                  placeholder="Quinto produto"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.productFive &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
            </div>
            <div className={`form -field ${errors3.productOne ? '-error' : ''}`}>
              <label htmlFor="serviceOne">
                Quais são os cinco serviços principais que você consegue oferecer?
              </label>
              <div className="form -group -gray">
                <input
                  type="text"
                  id="offerServiceOne"
                  name="serviceOne"
                  autoComplete="off"
                  placeholder="Primeiro serviço"
                  onChange={() => triggerValidation('productOne')}
                  ref={register3({
                    maxLength: 60,
                    validate: value => !(value.length < 3 && getValues('productOne').length < 3)
                  })}
                />
                { errors3.serviceOne?.type === 'maxLength' &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
                { errors3.serviceOne && errors3.serviceOne?.type !== 'maxLength' &&
                  <p className="form -message -error">Você precisa inserir ao menos um produto ou serviço que quer oferecer</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerServiceTwo"
                  name="serviceTwo"
                  autoComplete="off"
                  placeholder="Segundo serviço"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.serviceTwo &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerServiceThree"
                  name="serviceThree"
                  autoComplete="off"
                  placeholder="Terceiro serviço"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.serviceThree &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerServiceFour"
                  name="serviceFour"
                  autoComplete="off"
                  placeholder="Quarto serviço"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.serviceFour &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
              <div className="form -group -gray mt-1">
                <input
                  type="text"
                  id="offerServiceFive"
                  name="serviceFive"
                  autoComplete="off"
                  placeholder="Quinto serviço"
                  ref={register3({
                    maxLength: 60
                  })}
                />
                { errors3.serviceFive &&
                  <p className="form -message -error">Você pode digitar no máximo 60 caracteres aqui</p>
                }
              </div>
            </div>
            <div className={`form -field ${ errors3.availableToGivenWhen ? '-error' : ''}`}>
              <label htmlFor="availableToGivenWhen">
                Quando você está disponível para oferecê-los (hora/dia)?
              </label>
              <div className="form -group -gray">
                <input
                  type="text"
                  id="availableToGivenWhen"
                  name="availableToGivenWhen"
                  autoComplete="off"
                  placeholder="ex.: de 8h às 18h de segunda à sexta"
                  ref={register3({
                    required: true,
                    maxLength: 180
                  })}
                />
                { errors3.availableToGivenWhen &&
                  <p className="form -message -error">Por favor preencha a sua disponibilidade.</p>
                }
              </div>
            </div>
            <div className={`form -field ${ errors3.availableToGivenTime ? '-error' : ''}`}>
              <label htmlFor="availableToGivenTime">
                Com que frequência (quantidade máxima de tempo)?
              </label>
              <div className="form -group -gray">
                <input
                  type="text"
                  id="availableToGivenTime"
                  name="availableToGivenTime"
                  autoComplete="off"
                  placeholder="ex.: 6h por dia"
                  ref={register3({
                    required: true,
                    maxLength: 180
                  })}
                />
                { errors3.availableToGivenTime &&
                  <p className="form -message -error">Por favor preencha a sua frequência.</p>
                }
              </div>
            </div>
            <div className="form -field center mt-4">
              <button type="submit" className="button -register -median">
                <span className="button -text">
                  Salvar e continuar
                </span>
              </button>
            </div>
          </form>
          {stepFinished && !forceShowForm &&
            <SuccessEdit setForceShow={setForceShowForm} />
          }
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
}

export default ProfileStep3;